/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *
 */
import styled from 'styled-components';
import { Card } from 'react-bootstrap';

export const CardContainer = styled(Card)`
  width: 300px;
  border: none;
`;
